import BasePolicy from '@/policies/BasePolicy.js';

export default class PagePolicy extends BasePolicy {
    viewAny(user) {
        if (!this.$store.getters['InstitutionSettings/get']('page_enabled')) return false;

        return user.hasPermissionTo('view all pages') || user.hasGroupPermissionTo('view all pages');
    }
}
